import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatCurrency, formatDate } from "../utils/accountsHelpers";

const LedgerViewer = ({ lines = [] }) => {
  if (!lines.length) {
    return (
      <Typography color="text.secondary">No ledger lines found.</Typography>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Line No</TableCell>
            <TableCell>Account</TableCell>
            <TableCell>Narration</TableCell>
            <TableCell align="right">Debit</TableCell>
            <TableCell align="right">Credit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lines.map((line) => (
            <TableRow key={line.id}>
              <TableCell>{formatDate(line.transactionDate)}</TableCell>
              <TableCell>{line.lineNo}</TableCell>
              <TableCell>
                {line.accountCode} - {line.accountName}
              </TableCell>
              <TableCell>{line.narration || "-"}</TableCell>
              <TableCell align="right">
                {formatCurrency(line.debit || 0)}
              </TableCell>
              <TableCell align="right">
                {formatCurrency(line.credit || 0)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LedgerViewer;
